import { render, staticRenderFns } from "./CompanyRLSList.vue?vue&type=template&id=d16956de&scoped=true"
import script from "./CompanyRLSList.vue?vue&type=script&lang=js"
export * from "./CompanyRLSList.vue?vue&type=script&lang=js"
import style0 from "./CompanyRLSList.vue?vue&type=style&index=0&id=d16956de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16956de",
  null
  
)

export default component.exports